import React, {Component} from 'react'

export default class FillingWrapper extends Component {
  render() {
    return <div {...this.props} style={{width: '100%', height: '100%'}}>{this.props.children}</div>
  }
}
